export const SEARCH_PLACEHOLDER = "Email, Nome, Sub";

export const SEE_MORE_LABEL = "Ver mais";

export const USERS_PAGE_SIZE = 6;

export const LOAD_USERS_ERROR_MESSAGE = "Não foi possível carregar os usuários.";
